// extracted by mini-css-extract-plugin
export default {"inputsWrapper":"_-_-record-it-components-src-dateTime-DateTimeInput-__inputsWrapper"};